module.exports = __webpack_public_path__ + "img/4-twoImg.81afd283.png";